import { render } from "./Tag.vue?vue&type=template&id=1eb01c5c&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=1eb01c5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb01c5c"],['__file',"Views/Blog/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1eb01c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1eb01c5c', __exports__)) {
    api.reload('1eb01c5c', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=1eb01c5c&scoped=true", () => {
    api.rerender('1eb01c5c', render)
  })

}


export default __exports__